module.exports = __webpack_public_path__ + "img/nxt.8684fe31.svg";